import { Button, Menu, Text, Tooltip, Flex } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons";
import { RefreshCheckIcon, AssignNewideaIcon } from '../../../../../icons/x-symbol-svgrepo-com';

const AssignActionsMenu = ({
  type,
  actions,
}: {
  type?: string;
  actions: { label: string; tooltip?: string; icon?: string; onClick: () => void }[];
}) => {
  return (
    <Menu shadow="md">
      <Menu.Target>
        <Button
          data-testid={type === "bulk-evidence" ? undefined : "evidence-assign-actions-trigger"}
          color={type === 'bulk-evidence' ?  "black" : "indigo"} 
          styles={{ 
            root: { 
              height: type === 'bulk-evidence' ? "36px" :"32px",
              width: type === 'bulk-evidence' ? "36px" :"32px",
              margin: "0px", 
              padding: "0px",
              backgroundColor: type === 'bulk-evidence' ? "#363699" : "#5353D3", 
              '&:hover': {
                backgroundColor: type === 'bulk-evidence' ? "#363699" : "#5353D3 !important",
              },
              '&:active': {
                backgroundColor: type === 'bulk-evidence' ? "#363699" : "#5353D3 !important",
              }
            } }}>
          <IconChevronDown size={16} />
        </Button>
      </Menu.Target>
      <Menu.Dropdown ml= "-35px" sx={{ zIndex: 10001, borderRadius: "8px", width: "250px" }}>
        {actions.map((action, index) => (
          <Menu.Item key={index} w={"240px"} pl={"15px"} onClick={action.onClick}>
            {action.tooltip ? (
              <Tooltip label={action.tooltip} position="top" withArrow>
                <Text fz={14}>{action.label}</Text>
              </Tooltip>
            ) : (  
              <Flex>
                {action.icon === "another" ? (
                  <RefreshCheckIcon />
                ) : action.icon === "new" ? (
                  <AssignNewideaIcon />
                ) : null}
                <Text fz={14} style={{ marginLeft: action.icon ? "5px" : "0px", marginTop: "-2px" }}>{action.label}</Text>
              </Flex>
            )
            }
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default AssignActionsMenu;
